import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UtilityService } from "services/utility.service";
import { GfcStatus, ScoreCardModel } from "./eligibility/scorecard.model";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
import { BehaviorSubject, Observable } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
@Injectable({ providedIn: "root" })
export class GfcService {
  QRCodeULBGFC;
  scoringUrl = environment.config.gfcUrl;
  baseUrl = environment.config.gfcAppUrl;
  odfbase = environment.config.odfUrl;
  iecUrl = environment.config.iecUrl;
  iecmonitaringUrl = environment.config.pts;
  iecUrlSwach = environment.config.iecUrlSwach;
  mediaUrl = environment.config.mediaUrl;

  scoreData$ = new BehaviorSubject<ScoreCardModel>(null);
  ulbCode$ = new BehaviorSubject<number>(
    this.util.isUlbAccess() ? this.util.getAccessData()?.ULBCode : null
  );
  appStatus;
  gfcAssessmentYear;
  isSubmitted;
  isReapplyAllowed;
  scoreGeneratedOn;
  viewApplication = false;
  duration$ = new BehaviorSubject<{ days; hours; minutes; seconds }>(null);

  appliedType = {
    RE_ASSESSMENT: "Re-Assessment",
    RE_CERTIFICATE: "Re-Certification",
    APPLY_FOR_NEW: "New Certificate",
  };

  private componentColors = {
    MANDATORY: "#f8cbad",
    ESSENTIAL: "#f6c002",
    DESIRABLE: "#37b050",
    IMPORTANT: "#ff941a",
    ASPIRATIONAL: "#42ad49",
  };
  private color = {
    PRIMARY: "#131D30",
    ACCENT: "#E7ECF1",
    SECONDARY: "#ffc100",
    RED: "#ff3333",
    GREEN: "#267b38",
  };
  private componentColumns = [
    "Level",
    "Component",
    "Marks",
    "Qualified level",
    "Score",
    "Status",
  ];

  // For Ticker and Duration display in case of Query;
  allowedTime;
  remainingTime;

  query;

  constructor(
    private http: HttpClient,
    private util: UtilityService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    if (this.route.snapshot.params) {
      this.query = this.route.snapshot.params;
      // console.log(this.query, 'IDDDD');
      // this.service.query = this.route.snapshot.params;
      // this.service.getData();
    }
  }

  fetchDataGfcReport(id: string): Observable<any> {
    return this.http.get(
      `https://staging.sbmurban.org/api/v1/gfcapp/score-card/result/final/${id}`
    );
  }

  isEditable() {
    return !this.isSubmitted || this.appStatus === GfcStatus.RE_APPLY;
    // return false; // Because GFC Applications are stopped no more edits allowed.
  }
  get isAssementComplete() {
    if (
      this.appStatus === GfcStatus.DA_PASS ||
      this.appStatus === GfcStatus.DA_FAIL ||
      this.appStatus === GfcStatus.RE_APPLY
    ) {
      return true;
    }
    return false;
  }

  // Common CRUD methods......
  get(url: string) {
    return this.http.get<any>(this.baseUrl + url);
  }
  getOdf(url: string) {
    return this.http.get<any>(this.odfbase + url);
  }

  filterOdf(url: string, data) {
    return this.http.post<any>(this.odfbase + url, data);
  }

  save(url: string, data) {
    return this.http.post<any>(this.baseUrl + url, data);
  }
  update(url: string, id, data) {
    return this.http.put<any>(this.baseUrl + url + id, data);
  }
  delete(url: string, id) {
    return this.http.delete<any>(this.baseUrl + url + id);
  }
  deletedata(url: string, id) {
    return this.http.delete<any>(this.iecUrl + url + id);
  }
  getDetail(url: string, id, queryData = {}) {
    return this.http.get<any>(this.baseUrl + url + id, { params: queryData });
  }
  getList(url: string, queryData) {
    return this.http.get<any>(this.baseUrl + url, { params: queryData });
  }

  getodfList(url: string, queryData) {
    return this.http.get<any>(this.odfbase + url, { params: queryData });
  }

  getListSwacha(url: string, queryData) {
    return this.http.get<any>(this.iecUrlSwach + url, { params: queryData });
  }

  uploadFiles(data, service = "", isLive = 'false') {
    return this.http.post<any>(this.mediaUrl + "upload/multiple", data, {
      params: { isLive, service },
    });
  }
  uploadSingle(data, params = {}) {
    return this.http.post<any>(this.mediaUrl + "upload", data, { params });
  }

  getFileUrl(file, service = "") {
    return this.http.post<any>(
      this.mediaUrl + "upload/get",
      { filename: file },
      { params: service ? { service } : {} }
    );
  }
  uploadFilesIec(url: string, data) {
    debugger;
    return this.http.post<any>(this.iecUrl + url, data);
  }

  getFileUrlFolder(file, service = "") {
    return this.http.post<any>(
      this.mediaUrl + "upload/get",
      { filename: file },
      { params: service ? { subfolder: service } : {} }
    );
  }

  geScorecard(code = null, params = {}) {
    return this.http.get<any>(
      this.scoringUrl + `certification/eligibility/${code ? code : ""}`,
      { params, observe: "response" }
    );
  }

  /// added for postActivity
  uploadImageByFolder(file, params = {}) {
    const folder = "city";
    return this.http.post<any>(
      this.mediaUrl + `upload/multiple?service=${folder}`,
      file,
      { params }
    );
  }
  uploadSingleImageByFolder(file, params) {
    const folder = "city";
    return this.http.post<any>(
      this.mediaUrl + `upload/?service=${folder}`,
      file,
      { params }
    );
  }
  // getUpladFileByFOlder
  getuploadImageByFolder(file) {
    const folder = "city";
    return this.http.post<any>(this.mediaUrl + `upload/get?service=${folder}`, {
      filename: file,
    });
  }
  uploadVideoByFolder(file, params = {}) {
    const folder = "city";
    return this.http.post<any>(
      this.mediaUrl + `upload/multiple?service=${folder}`,
      file,
      { params }
    );
  }
  getuploadVideoByFolder(file) {
    const folder = "city";
    return this.http.post<any>(this.mediaUrl + `upload/get?service=${folder}`, {
      filename: file,
    });
  }

  checkMandatoryComponent(comp) {
    if (comp.isMandatory) {
      const files = comp.evidences.reduce((a, e) => a + e.files.length, 0);
      if (files > 0) {
        comp.error = false;
      }
    } else {
      comp.error = false;
    }
  }

  generateReport(body) {
    const headers = new HttpHeaders().set("Content-Type", "application/pdf");
    return this.http.post<any>(
      environment.config.apiUrl + "file/htmltopdf/gfcreport",
      body,
      { headers, observe: "response", responseType: "blob" as "json" }
    );
  }

  downloadPdf(scoreData, hierarchy, detailed = false) {
    if (scoreData && scoreData?.sections?.length) {
      const doc = new jsPDF({ orientation: "p", unit: "mm", format: "a4" });
      doc.setFillColor(204, 204, 204, 0);
      this.mainHeader(doc);
      this.header(doc, hierarchy);
      this.cumulativeScores(scoreData, doc);
      scoreData.sections.forEach((e) => {
        const color = this.componentColors[e.componentType.toUpperCase()];
        this.renderComponentsData(doc, e, color);
      });
      if (detailed) {
        this.renderTitle(
          doc,
          "Ward Level Details",
          doc.previousAutoTable.finalY + 10,
          { fontSize: 15 }
        );
        scoreData.sections.forEach((e) => {
          const color = this.componentColors[e.componentType.toUpperCase()];
          e.components.forEach((c) => {
            if (c.wards?.length) {
              this.renderWardData(
                doc,
                `${c.identifier} ${c.name}`,
                c.wards,
                color
              );
            }
          });
        });
        this.renderTitle(
          doc,
          "City Level Questions",
          doc.previousAutoTable.finalY + 10,
          { fontSize: 15 }
        );
        scoreData.sections.forEach((e) => {
          const color = this.componentColors[e.componentType.toUpperCase()];
          e.components.forEach((c) => {
            if (c?.questions?.length) {
              this.renderQuestionData(
                doc,
                `${c.identifier} ${c.name}`,
                c.questions,
                color
              );
            }
          });
        });
        this.renderTitle(
          doc,
          "Ward Level Questions",
          doc.previousAutoTable.finalY + 5
        );
        scoreData.sections.forEach((e) => {
          const color = this.componentColors[e.componentType.toUpperCase()];
          e.components.forEach((c) => {
            if (c?.wards?.length) {
              c.wards.forEach((w) => {
                this.renderTitle(
                  doc,
                  "Ward Number " + w.wardNumber,
                  doc.previousAutoTable.finalY + 5
                );
                if (w.questions.length) {
                  this.renderQuestionData(
                    doc,
                    `${c.identifier} ${c.name}`,
                    w.questions,
                    color
                  );
                }
              });
            }
          });
        });
        doc.save(
          `${hierarchy ? hierarchy.ulb + "(" + hierarchy.ulbCode + ")" + "_" : ""
          }GFC_Scorecard_${this.gfcAssessmentYear || 2021}_Detail.pdf`
        );
      } else {
        doc.save(
          `${hierarchy ? hierarchy.ulb + "(" + hierarchy.ulbCode + ")" + "_" : ""
          }GFC_Scorecard_${this.gfcAssessmentYear || 2021}_Summary.pdf`
        );
      }
    } else {
      this.util.showError(
        "Scorecard not avaialable. Please contact support",
        ""
      );
    }
  }
  private mainHeader(doc) {
    const styles = {
      valign: "middle",
      halign: "center",
      fontStyle: "bold",
      textColor: "#fff",
      fontSize: 18,
      cellPadding: 1,
    };
    doc.setFillColor("#000");
    doc.rect(0, 0, 210, 30, "F");
    doc.autoTable({
      startY: 5,
      theme: "plain",
      body: [
        [{ content: "STAR RATING OF GARBAGE FREE CITIES 2024", styles }],
        [
          {
            content: "SELF-ASSESSMENT",
            styles: { ...styles, textColor: this.color.SECONDARY },
          },
        ],
      ],
    });
  }
  private header(doc, hierarchy) {
    const { state, district, ulb, ulbCode } = hierarchy;
    const styles = {
      valign: "middle",
      halign: "center",
      fontStyle: "bold",
      fontSize: 12,
      textColor: "#fff",
    };
    doc.setFillColor("#1a2842");
    doc.rect(0, 30, 210, 15, "F");
    doc.autoTable({
      startY: 30,
      theme: "plain",
      body: [
        [
          {
            content: "STATE",
            styles: { ...styles, textColor: this.color.SECONDARY },
          },
          { content: state || state, styles },
          { content: " " },
          {
            content: "DISTRICT",
            styles: { ...styles, textColor: this.color.SECONDARY },
          },
          { content: district, styles },
          { content: " " },
          {
            content: "CITY/ULB",
            styles: { ...styles, textColor: this.color.SECONDARY },
          },
          { content: ulb, styles },
          { content: " " },
          {
            content: "ULB CODE",
            styles: { ...styles, textColor: this.color.SECONDARY },
          },
          { content: ulbCode, styles },
        ],
      ],
    });
  }
  private cumulativeScores(scoreData, doc) {
    const styles = {
      valign: "middle",
      halign: "right",
      fontStyle: "bold",
      cellPadding: 0,
      fontSize: 10,
      textColor: "#fff",
    };
    const compStyles = {
      valign: "middle",
      halign: "left",
      fontStyle: "bold",
      cellPadding: 3,
      fontSize: 12,
    };
    doc.setFillColor(this.color.PRIMARY);
    doc.rect(0, 45, 210, 30, "F");
    doc.autoTable({
      startY: 50,
      theme: "plain",
      body: [
        [
          {
            content: "As per data submitted in SBM (Urban) Portal",
            styles: { ...styles, halign: "left" },
          },
          { content: "Eligible for ", styles },
          {
            content: scoreData.starRating
              ? `${scoreData.starRating} Stars`
              : "Not Qualified",
            styles: {
              ...styles,
              textColor: scoreData.starRating
                ? this.color.SECONDARY
                : this.color.RED,
            },
          },
        ],
      ],
    });
    doc.autoTable({
      theme: "plain",
      startY: 57,
      body: [
        [
          {
            content: "Important",
            styles: {
              ...compStyles,
              fillColor: this.componentColors.IMPORTANT,
            },
          },
          {
            content: scoreData.sections[0].totalComponentScore,
            styles: {
              ...compStyles,
              halign: "right",
              fillColor: this.componentColors.IMPORTANT,
            },
          },
          { content: "" },
          {
            content: "Aspirational",
            styles: {
              ...compStyles,
              fillColor: this.componentColors.ASPIRATIONAL,
            },
          },
          {
            content: scoreData.sections[1].totalComponentScore,
            styles: {
              ...compStyles,
              halign: "right",
              fillColor: this.componentColors.ASPIRATIONAL,
            },
          },
          // { content: '' },
          // { content: 'Desirable', styles: { ...compStyles, fillColor: this.componentColors.DESIRABLE } }
          // {
          //   content: scoreData.sections[2].totalComponentScore,
          //   styles: { ...compStyles, halign: 'right', fillColor: this.componentColors.DESIRABLE }
          // }
        ],
      ],
    });
    this.renderTitle(doc, "SELF-ASSESSMENT SUMMARY", 80);
  }

  private renderComponentsData(doc, data, fillColor) {
    const styles = {
      valign: "middle",
      halign: "left",
      fontStyle: "bold",
      cellPadding: 3,
      fontSize: 10,
      fillColor,
    };
    doc.autoTable({
      startY: doc.previousAutoTable.finalY + 4,
      theme: "plain",
      pageBreak: "auto",
      body: [
        [
          { content: `${data.componentType} PARAMETER LEVEL`, styles },
          {
            content: data.totalComponentScore,
            styles: { ...styles, halign: "right" },
          },
        ],
      ],
    });
    doc.autoTable({
      startY: doc.previousAutoTable.finalY,
      theme: "plain",
      pageBreak: "auto",
      columns: this.componentColumns,
      headStyles: {
        valign: "middle",
        halign: "left",
        cellPadding: 2,
        fontSize: 10,
        fillColor: this.color.PRIMARY,
        textColor: "#fff",
      },
      body: data.components.map((e) => {
        const styles = {
          valign: "middle",
          halign: "left",
          cellPadding: 2,
          fontSize: 10,
          lineWidth: 0.25,
          lineColor: "#222",
          fillColor,
        };
        return [
          { content: e.accessLevel, styles },
          { content: e.name, styles },
          { content: e.marks, styles },
          { content: e.qualifiedForLevel, styles },
          // { content: e.weightage, styles },
          { content: e.score, styles },
          {
            content: e.isQualified ? `PASS` : `FAIL`,
            styles: {
              ...styles,
              fontStyle: "bold",
              textColor: "#fff",
              cellWidth: 20,
              fillColor: e.isQualified ? this.color.GREEN : this.color.RED,
            },
          },
        ];
      }),
    });
  }
  private renderTitle(doc, content: string, startY, styles = {}) {
    doc.autoTable({
      startY,
      theme: "plain",
      body: [
        [
          {
            content,
            styles: {
              valign: "middle",
              halign: "left",
              fontStyle: "bold",
              cellPadding: 0,
              fontSize: 12,
              textColor: this.color.PRIMARY,
              ...styles,
            },
          },
        ],
      ],
    });
  }

  private renderWardData(doc, component: string, data, fillColor) {
    this.renderTitle(doc, component, doc.previousAutoTable.finalY + 5, {
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: this.color.PRIMARY,
      fillColor: this.color.ACCENT,
    });
    doc.autoTable({
      startY: doc.previousAutoTable.finalY,
      theme: "plain",
      pageBreak: "auto",
      columns: ["Ward Number", "Qualified For", "Score", "Status"],
      headStyles: {
        valign: "middle",
        halign: "left",
        fontStyle: "bold",
        cellPadding: 3,
        fontSize: 10,
        fillColor: this.color.PRIMARY,
        textColor: "#fff",
      },
      body: data?.map((e) => {
        const styles = {
          valign: "middle",
          halign: "left",
          cellPadding: 2,
          fontSize: 10,
          lineWidth: 0.25,
          lineColor: "#222",
          fillColor,
        };
        return [
          { content: e.wardNumber, styles },
          { content: e.level, styles },
          { content: e.score, styles },
          {
            content: e.qualified ? `PASS` : `FAIL`,
            styles: {
              ...styles,
              fontStyle: "bold",
              textColor: "#fff",
              cellWidth: 20,
              fillColor: e.qualified ? this.color.GREEN : this.color.RED,
            },
          },
        ];
      }),
    });
  }
  private renderQuestionData(doc, question, data, fillColor) {
    this.renderTitle(doc, question, doc.previousAutoTable.finalY + 5, {
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: this.color.PRIMARY,
      fillColor: this.color.ACCENT,
    });
    doc.autoTable({
      startY: doc.previousAutoTable.finalY,
      theme: "plain",
      pageBreak: "auto",
      columns: ["Identifier", "Question", "Value"],
      headStyles: {
        valign: "middle",
        halign: "left",
        fontStyle: "bold",
        cellPadding: 3,
        fontSize: 10,
        fillColor: this.color.PRIMARY,
        textColor: "#fff",
      },
      body: data.map((e) => {
        const styles = {
          valign: "middle",
          halign: "left",
          cellPadding: 2,
          fontSize: 10,
          lineWidth: 0.25,
          lineColor: "#222",
          fillColor,
        };
        return [
          { content: e.identifier, styles },
          { content: e.description, styles },
          { content: e.answer, styles },
          // { content: isNaN(e.answer) ? e.answer : parseFloat(e.answer).toFixed(3), styles },
        ];
      }),
    });
  }

  // IEC CRUD methods......safaimitra
  saveIec(url: string, data) {
    return this.http.post<any>(this.iecUrl + url, data);
  }
  saveIecSwacha(url: string, data) {
    return this.http.post<any>(this.iecUrlSwach + url, data);
  }
  saveVerifiedState(url: string, data) {
    return this.http.post<any>(this.iecUrl + url, data);
  }
  updateVerifiedState(url: string, id, data) {
    return this.http.put<any>(this.iecUrl + url + id, data);
  }
  updateIec(url: string, id, data) {
    return this.http.put<any>(this.iecUrl + url + id, data);
  }
  deleteIec(url: string, id) {
    return this.http.delete<any>(this.iecUrl + url + id);
  }
  getStateData(url: string, id) {
    return this.http.get<any>(this.iecUrl + url + id);
  }
  getDetailIec(url: string, id) {
    return this.http.get<any>(this.iecUrl + url + id);
  }
  getListIec(url: string, queryData) {
    return this.http.get<any>(this.iecUrl + url, { params: queryData });
  }
  getDeclarationList(url: string, queryData) {
    return this.http.get<any>(this.iecUrl + url, { params: queryData });
  }
  getDeclaration(url) {
    return this.http.get<any>(this.iecUrl + url);
  }
  //get excel download
  getExcelLife(url: string, queryData) {
    return this.http.get<any>(this.iecUrl + url, { params: queryData });
  }

  // Get GFC Dashboard
  getGFCDashboard() { }

  saveSegregation(url: string, data) {
    return this.http.post<any>(this.iecUrl + url, data);
  }
  getSegregation(url: string, ulbId) {
    return this.http.get<any>(this.iecUrl + url + ulbId);
  }

  getSchoolActivities(url: string, queryData) {
    return this.http.get<any>(this.iecUrl + url, { params: queryData });
  }

  getschoolActivity(url: string, userId) {
    return this.http.get<any>(this.iecUrl + url + userId);
  }
  getulbList(url: string, queryData) {
    return this.http.get<any>(this.iecUrl + url, { params: queryData });
  }
  // sabbc api
  saveSabbc(url: string, data) {
    return this.http.post<any>(this.iecUrl + url, data);
  }

  getListSabbc(url: string, queryData) {
    return this.http.get<any>(this.iecUrl + url, { params: queryData });
  }

  updateSabbc(url: string, id, data) {
    return this.http.put<any>(this.iecUrl + url + id, data);
  }

  getDetailsabbc(url: string, id) {
    return this.http.get<any>(this.iecUrl + url + id);
  }

  deleteLeader(url: string, id) {
    return this.http.delete<any>(this.iecUrl + url + id);
  }

  deleteMobilization(url: string, id) {
    return this.http.delete<any>(this.iecUrl + url + id);
  }

  checkWeekValueExist(url: string, data) {
    return this.http.post<any>(this.iecUrl + url, data);
  }

  getListIecMonitaring(url: string, queryData) {
    // console.log(url, "URLLLLLLll")
    return this.http.get<any>(this.iecmonitaringUrl + url, {
      params: queryData,
    });
  }

  saveIecMonitaring(url: string, data) {
    return this.http.post<any>(this.iecmonitaringUrl + url, data);
  }

  updateIecMonitaring(url: string, id, data) {
    return this.http.put<any>(this.iecmonitaringUrl + url + id, data);
  }
  getDetailIecMonitaring(url: string, iecReportId) {
    return this.http.get<any>(this.iecmonitaringUrl + url + iecReportId);
  }
  deleteIecMonitaring(url: string, iecReportId) {
    return this.http.delete<any>(this.iecmonitaringUrl + url + iecReportId);
  }

  uploadFilesDafr(data, service = "", subfolder = "", isLive = 'false') {
    return this.http.post<any>(this.mediaUrl + "upload/multiple", data, {
      params: { service, subfolder, isLive },
    });
  }

  getFileUrlDafr(file, service = "", subfolder = "") {
    return this.http.post<any>(
      this.mediaUrl + "upload/get",
      { filename: file },
      { params: { service, subfolder } }
    );
  }

  getVehicleCounter(id){
    return this.http.get<any>(this.iecUrlSwach + "safaidetail/vehicle_counter/" + id);
  }


}
